import { Component } from '@angular/core';
import { Breadcrumbs } from 'core/services';

@Component({
    selector: 'xm-account-breadcrumb',
    styleUrls: ['./breadcrumb.scss'],
    templateUrl: './breadcrumb.html',
    standalone: false
})
export class XmAccountBreadcrumbComponent {
    public breadcrumb: Breadcrumbs;

    constructor(breadcrumb: Breadcrumbs) {
        Object.assign(this, { breadcrumb });
    }
}
